import { ApplicationAttachmentType } from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import { ATTACHMENT_TYPES } from 'src/constants/attachmentTypes';

export const mapGraphAttachmentTypeToStore = (
  attachmentType: ApplicationAttachmentType,
): ATTACHMENT_TYPES => {
  switch (attachmentType) {
    case ApplicationAttachmentType.RESUME:
      return ATTACHMENT_TYPES.RESUME;
    case ApplicationAttachmentType.COVER_LETTER:
      return ATTACHMENT_TYPES.COVER_LETTER;
    case ApplicationAttachmentType.SELECTION_CRITERIA:
      return ATTACHMENT_TYPES.SELECTION_CRITERIA;
    default:
      return ATTACHMENT_TYPES.HIRER_UPLOADED;
  }
};
